import dayjs, { Dayjs } from "dayjs"
import tz from "dayjs/plugin/timezone"

dayjs.extend(tz)
dayjs.tz.setDefault("Australia/Sydney")

type DateLike = string | Date | Dayjs

// eg. 22-23 Aug 2026, or 28 Aug - 5 Sep 2026, or 28 Dec 2026 - 5 Jan 2027
export function formatShortDateRange(start: DateLike, end: DateLike) {
  const startDate = dayjs(start)
  const endDate = dayjs(end)

  if (startDate.year() === endDate.year()) {
    if (startDate.month() === endDate.month()) {
      if (startDate.day() === endDate.day()) {
        return startDate.format("D MMM YYYY")
      }
      return `${startDate.format("D")}-${endDate.format("D MMM YYYY")}`
    } else {
      return `${startDate.format("D MMM")} - ${endDate.format("D MMM YYYY")}`
    }
  } else {
    return `${startDate.format("D MMM YYYY")} - ${endDate.format("D MMM YYYY")}`
  }
}

export function formatShortDate(date: DateLike) {
  const startDate = dayjs(date)
  return startDate.format("D MMM YYYY")
}

export function formatDateSortable(date: DateLike) {
  const startDate = dayjs(date)
  return startDate.format("YYYY-MM-DD")
}

export function formatTime(date: DateLike) {
  return dayjs(date).format("h:mma").replace(":00", "")
}

export function formatDateTime(date: DateLike) {
  const startDate = dayjs(date)
  return startDate.format("D MMM YYYY, h:mma").replace(":00", "")
}
